import React from "react";

import { Grid, Switch, Typography } from "@mui/material";

export function ChartCaptionToggle({ label, color, isChecked, onToggle }: ChartCaptionToggleProps) {
  return (
    <Grid item direction="row" alignItems="center">
      <Switch
        defaultChecked
        checked={isChecked}
        onChange={(e) => onToggle(e.target.checked, label)}
        size="small"
        sx={{ "&.MuiSwitch-root .Mui-checked +.MuiSwitch-track": {backgroundColor: color}, "&.MuiSwitch-root .MuiSwitch-thumb": {backgroundColor: color} }} />
      <Typography variant="caption">{label}</Typography>
    </Grid>
  );
}

export type ChartCaptionToggleProps =
  | {
      label: string;
      color: string;
      isChecked: boolean,
      onToggle: (arg0: boolean, arg1: string) => void
    };